import React from "react";
import { getFontAwesomeIcon, getColSpanClass } from "../../../utils";
import { BaseDetailFieldProps } from "./types";
import renderBaseRowDetailValue from "./renderBaseDetailFieldValue";
import { placeholderImage } from "../../../assets";
import { BaseToolTip } from "../..";

const BaseDetailField: React.FC<BaseDetailFieldProps> = ({
	dataItem,
	field,
	allFields,
	allData,
	containerWidth = "w-full",
	iconStyle = "solid",
	mobileBreakpoint,
	isDisabled,
	imageClasses = "rounded-full w-18px h-18px",
	defaultLabelTextClasses,
	defaultFlexDirection,
	defaultDetailGridClasses,
	defaultValueTextClasses,
	defaultDetailIconClasses,
	dataTestId,
	currencyCharacter,
}) => {
	const {
		uuid,
		detailGridClasses,
		alignment,
		hasBottomBorder,
		bottomBorderClasses,
		hasTopBorder,
		topBorderClasses,
		label,
		labelTextClasses,
		disabledClasses,
		hideLabel,
		labelTooltip,
		valueTextClasses,
		hasValueLeftIconOne,
		valueIconClassesOne,
		valueIconOneWeight,
		hasValueLeftIconTwo,
		valueIconClassesTwo,
		valueIconTwoWeight,
		hasValueImage,
		valueImageAlt,
		hasValueRightIcon,
		detailIconClasses,
		valueType,
		colSpan,
		breakPointColSpan,
	} = field || {};

	//////////// CLASSNAMES ////////////
	const containerClasses = [
		containerWidth,
		detailGridClasses,
		defaultDetailGridClasses,
		colSpan && getColSpanClass(colSpan),
		// breakPointColSpan && getBreakpointColSpan(breakPointColSpan),
	]
		.filter(Boolean)
		.join(" ");

	const secondaryContainerClasses = [
		"flex",
		"w-full",
		alignment,
		defaultFlexDirection,
		mobileBreakpoint,
		hasBottomBorder && bottomBorderClasses,
		hasTopBorder && topBorderClasses,
	]
		.filter(Boolean)
		.join(" ");

	const labelClassesVar = [
		isDisabled
			? disabledClasses
			: labelTextClasses || defaultLabelTextClasses,
		hideLabel && "hidden",
	]
		.filter(Boolean)
		.join(" ");

	const valueClasses = [valueTextClasses, defaultValueTextClasses]
		.filter(Boolean)
		.join(" ");

	//////////// CONDITIONS TO VARS ////////////
	const leftIcon = (
		<div className={`px-1 ${valueIconClassesOne}`}>
			{hasValueLeftIconOne &&
				getFontAwesomeIcon(
					hasValueLeftIconOne,
					valueIconOneWeight as "solid" | "regular" | "light",
				)}
		</div>
	);

	const secondaryLeftIcon = (
		<div className={`px-1 ${valueIconClassesTwo}`}>
			{hasValueLeftIconTwo &&
				getFontAwesomeIcon(
					hasValueLeftIconTwo,
					(valueIconTwoWeight as "solid" | "regular" | "light") ||
						"regular",
				)}
		</div>
	);

	const rightIcon = (
		<div
			className={`px-1 ${detailIconClasses || defaultDetailIconClasses}`}
		>
			{hasValueRightIcon &&
				getFontAwesomeIcon(hasValueRightIcon, iconStyle)}
		</div>
	);

	const valueImage = (
		<div className={`px-1 ${imageClasses}`}>
			<img
				src={hasValueImage || placeholderImage}
				alt={valueImageAlt || ""}
			/>
		</div>
	);

	return field ? (
		<div
			key={uuid}
			className={containerClasses}
			data-testid={dataTestId || "base-detail-field"}
		>
			<div className={secondaryContainerClasses}>
				<div className={labelClassesVar}>
					<dt>{label}</dt>
				</div>
				{labelTooltip && label && (
					<BaseToolTip
						message={labelTooltip}
						icon="circleInfo"
						toolTipPlacement="right"
					/>
				)}
				<dd className={valueClasses}>
					{/* VALUE ICON ONE */}
					{hasValueLeftIconOne && iconStyle && leftIcon}

					{/* VALUE ICON TWO */}
					{hasValueLeftIconTwo && iconStyle && secondaryLeftIcon}

					{hasValueImage &&
						iconStyle &&
						dataItem !== "—" &&
						valueImage}
					{renderBaseRowDetailValue(
						field,
						dataItem,
						isDisabled,
						allFields,
						allData,
						currencyCharacter,
					)}
					{hasValueRightIcon && iconStyle && rightIcon}
				</dd>
			</div>
		</div>
	) : null;
};

export default BaseDetailField;
